import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formEditable, TFormEditableCodec } from "../../../shared/src/codecs/types/formEditable";
import { ListingFull1, TListingFull1Codec } from "../Listing";

export const ListingFull1Editable: TFormEditableCodec<TListingFull1Codec> = formEditable(ListingFull1);

export type TListingFull1EditableCodec = typeof ListingFull1Editable;

export type TListingFull1Editable = TTypeOfCodec<TListingFull1EditableCodec>;
